export const TypeFile = () => (
    <div>
        <h5>Los alumnos responderán la pregunta adjuntando un archivo</h5>
    </div>
)
